// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ExtendProbationMutationVariables = Types.Exact<{
  input: Types.ExtendProbationInput;
}>;

export type ExtendProbationMutation = { __typename?: 'Mutation' } & {
  extendProbation: { __typename?: 'ProbationReviewOutput' } & Pick<Types.ProbationReviewOutput, 'id'>;
};

export const ExtendProbationDocument = /*#__PURE__*/ gql`
    mutation ExtendProbation($input: ExtendProbationInput!) {
  extendProbation(input: $input) {
    id
  }
}
    `;
export type ExtendProbationMutationFn = Apollo.MutationFunction<
  ExtendProbationMutation,
  ExtendProbationMutationVariables
>;

/**
 * __useExtendProbationMutation__
 *
 * To run a mutation, you first call `useExtendProbationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendProbationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendProbationMutation, { data, loading, error }] = useExtendProbationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtendProbationMutation(
  baseOptions?: Apollo.MutationHookOptions<ExtendProbationMutation, ExtendProbationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExtendProbationMutation, ExtendProbationMutationVariables>(
    ExtendProbationDocument,
    options,
  );
}
export type ExtendProbationMutationHookResult = ReturnType<typeof useExtendProbationMutation>;
export type ExtendProbationMutationOptions = Apollo.BaseMutationOptions<
  ExtendProbationMutation,
  ExtendProbationMutationVariables
>;
